import { render } from "./TopArea.vue?vue&type=template&id=1a4be721"
import script from "./TopArea.vue?vue&type=script&lang=js"
export * from "./TopArea.vue?vue&type=script&lang=js"

import "./TopArea.vue?vue&type=style&index=0&id=1a4be721&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.2.13_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__